// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateAndEdit_wrapper__tp1m1","text":"CreateAndEdit_text__pnH4a"};